import React from 'react';
import { node, func, string, bool, arrayOf, number } from 'prop-types';
import { Flex } from '@mixins';
import { theme } from '@styles';
import Input from '../styles';

const TextInput = ({ onChange, value, placeholder, children, hasError, hideCursor, onBlur, isRound, fontSize }) => (
  <Flex
    width="100%"
    alignItems="center"
    justifyContent="start"
    {...(isRound && { border: `1px solid ${hasError ? theme.color.red : '#D9D9D9'}`, pl: '10px', borderRadius: '6px' })}
    {...(!isRound && { borderBottom: `1px solid ${hasError ? theme.color.red : theme.color.gray[200]}` })}
  >
    {children}
    <Input
      onBlur={onBlur}
      hideCursor={hideCursor}
      width="100%"
      border="none"
      py={['3px', '3px', '5px', '7px']}
      fontSize={fontSize}
      fontWeight={400}
      color={theme.color.gray[500]}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
    />
  </Flex>
);

TextInput.defaultProps = {
  isRound: false,
  children: <Flex />,
  hasError: false,
  hideCursor: false,
  onBlur: () => {},
  fontSize: [12, 12, 14, 16],
};

TextInput.propTypes = {
  fontSize: arrayOf(number),
  isRound: bool,
  onBlur: func,
  onChange: func.isRequired,
  value: string.isRequired,
  placeholder: string.isRequired,
  children: node,
  hasError: bool,
  hideCursor: bool,
};

export default TextInput;
